<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-oqa" id="oqa">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-oqa data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Oocyte Quality Assessment
              </label>
            </div>
            <div class="col-md-6 float-right text-align-end padding-right-0px display-edit">
              <div class="row float-right margin-left-0px margin-right-0px">
                <div class="offset-md-3 col-md-1 padding-left-0px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images">
        <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
      </a>-->
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-long-arrow-alt-up font-size-11"></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <!--<button type="button"
              class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
              name="upload">
        <i class="fas fa-plus font-size-11"></i>
      </button>-->
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-long-arrow-alt-down font-size-11 "></i>
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Well Culture'" title="print" (click)="printoocyte()">
                    <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
                  </a>
                  <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Droplet Culture'" title="print" (click)="printoocytedroplet()">
                    <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
                  </a>
                </div>
              </div>
              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="edit">
    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
  </a>-->
             
            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row  margin-top-10">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">

                <div class="card-body padding-all-0px">
                  <div class="row" *ngIf="GradingModel=='Well Culture'">
                    <div class="col-md-12 ">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero">

                            <thead class="">
                              <tr>


                                <th class="padding-top-4px padding-bottom-4px width-47px font-weight-normal">Sno</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Well#</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Occ/Denuded</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Morphology</th>


                              </tr>
                            </thead>
                            <tbody class="table-body">
                              <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                              <!--</ng-container>-->
                              <tr *ngFor="let l of CurrentOocyteQualityAssessmentByCodeController;let i = index">


                                <td class="text-align-center padding-top-0px padding-bottom-0px padding-left-0px">{{i+1}}</td>
                                <td class="text-align-left padding-top-0px padding-bottom-0px padding-right-0px"><label class="margin-bottom-0px margin-left-5px">{{l.WellNo}}</label> </td>

                                <td class="padding-top-0px padding-bottom-0px">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>
                                <td class="padding-all-0px">
                                  <!--<CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                  required></CodeTypeValue>-->
                                  {{l.technique}}
                                </td>





                              </tr>
                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="GradingModel=='Droplet Culture'">
                    <!--<label>OQA</label>-->
                    <div class="col-md-6 ">
                      <div class="table-component">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">
                            <caption>OQA</caption>
                            <!--<thead class="">
    <tr>
      <th class="padding-top-4px padding-bottom-4px td-width-10px"></th>
      <th class="td-well-width-79px padding-top-4px padding-bottom-4px"></th>


    </tr>
  </thead>-->

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentOocyteMaturityByCycleController">


                                <td class="padding-top-4px padding-bottom-4px ">

                                  <!--<CodeTypeValue CodeType="OCTML"
        [(ngModel)]="l.MaturityLevel" SelectedValue="l.MaturityLevel"
        required></CodeTypeValue>-->
                                  <label class="margin-bottom-0px">{{l.MaturityLevel}}</label>
                                </td>
                                <td class="padding-top-4px padding-bottom-4px">
                                  <!--<input type="text" class="form-control " placeholder="" [(ngModel)]="l.OccCount"
        maxlength="2" required>-->
                                  <label class="margin-bottom-0px font-size-18px">{{l.OccCount}}</label>
                                </td>
                                <!--<td class="padding-all-0px">
        <input type="text" class="form-control text-align-right" placeholder="" [(ngModel)]="l.DenudedCount"
               maxlength="2" required>
      </td>-->

                              </tr>

                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="GradingModel=='Droplet Culture'">
                    <!--<label>Oocyte Abnormalities</label>-->
                    <div class="col-md-6 ">
                      <div class="table-component">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">
                            <caption>Oocyte Abnormalities</caption>
                            <!--<thead class="">
                              <tr>
                                <th class="padding-top-4px padding-bottom-4px"></th>
                                <th class="td-well-width-79px padding-top-4px padding-bottom-4px"></th>
                               

                              </tr>
                            </thead>-->

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentOocyteMorphologyByCycleController">


                                <td class="padding-top-0px padding-bottom-0px">
                                  <!--<CodeTypeValue CodeType="IVFMR"
        [(ngModel)]="l.Morphology" SelectedValue="l.Morphology"
        required></CodeTypeValue>-->
                                  <label class="margin-bottom-0px">{{l.Morphology}}</label>
                                  <!--<CodeTypeValue CodeType="IVFMR"></CodeTypeValue>-->

                                </td>
                                <td class="padding-top-0px padding-bottom-0px">
                                  <!--<input type="text" class="form-control text-align-right" placeholder="" [(ngModel)]="l.OocyteCount"
        maxlength="2" required>-->
                                  <label class="margin-bottom-0px font-size-18px">{{l.OocyteCount}}</label>
                                </td>

                              </tr>

                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>


  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
